module.exports = __webpack_public_path__ + "img/list_7_tc.40927774.png";